module.exports = __webpack_public_path__ + "img/google-play-en.8061d14.png";